import { Component, Input, OnInit } from '@angular/core';
import { ProductCard } from 'src/app/modules/shared/components/shared-product/shared-product-class';
import { Product } from 'src/app/modules/shared/models/products.model';

@Component({
  selector: 'related-products',
  templateUrl: './related-products.component.html',
  styleUrls: ['./related-products.component.scss'],
})
export class RelatedProductsComponent implements OnInit {
  @Input() list: Product[];
  @Input() isDesktop: boolean;
  relatedProducts: ProductCard[];

  featuredSliderConfig;

  constructor() {}

  ngOnInit(): void {
    this.relatedProducts = this.list.map((i) => new ProductCard(i, undefined));
    this.setSliderConfig();
  }

  private setSliderConfig() {
    const slidesToShow = 3;
    let config = {
      arrows: false,
      dots: true,
      infinite: true,
      autoplay: true,
      slidesToScroll: 3,
      slidesToShow,
    };

    if (this.relatedProducts.length < slidesToShow) {
      config = { ...config, dots: false };
    }

    this.featuredSliderConfig = config;
  }
}
